import { RootState } from 'typesafe-actions';

/**
 * Создает рутовый немемоизированный селектор для фичи
 *
 * @param featureName: Имя фичи в Redux
 */
export function createFeatureSelector<T extends keyof RootState['pdp']>(featureName: T) {
  return (state: RootState) => state?.pdp?.[featureName];
}
